import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ITela } from '../../objeto/ITela';
import { SuporteAvaliacaoService } from '../../services/suporte-avaliacao.service';

@Component({
  selector: 'app-tela-avaliar-suporte',
  templateUrl: './tela-avaliar-suporte.component.html',
  styleUrls: ['./tela-avaliar-suporte.component.scss']
})
export class TelaAvaliarSuporteComponent implements OnInit, ITela {
  token = '';
  avaliacao: any = null;
  resposta: any = {
    nota: 0,
    resolveuProblema: null,
    comentario: ''
  };
  carregando = false;
  enviando = false;
  enviado = false;
  msgErro = '';

  constructor(private activatedRoute: ActivatedRoute,
              private suporteAvaliacaoService: SuporteAvaliacaoService) {
    this.activatedRoute.params.subscribe(params => {
      this.token = params['token'];
    });
  }

  ngOnInit(): void {
    this.carregueAvaliacao();
  }

  deveExibirTopo() {
    return false;
  }

  deveExibirMenu() {
    return false;
  }

  deveTerBordas() {
    return true;
  }

  deveExibirBannerTema() {
    return false;
  }

  fecheTela() {
  }

  carregueAvaliacao() {
    this.carregando = true;
    this.msgErro = '';

    this.suporteAvaliacaoService.obtenhaAvaliacao(this.token).then((avaliacao: any) => {
      this.avaliacao = avaliacao;

      if (avaliacao && avaliacao.status === 'RESPONDIDA') {
        this.enviado = true;
        this.resposta.nota = avaliacao.nota || 0;
        this.resposta.resolveuProblema = avaliacao.resolveuProblema;
        this.resposta.comentario = avaliacao.comentario || '';
      }
    }).catch(erro => {
      this.msgErro = erro || 'Não foi possível carregar a avaliação.';
    }).finally(() => {
      this.carregando = false;
    });
  }

  enviarAvaliacao() {
    this.msgErro = '';

    if (!this.resposta.nota) {
      this.msgErro = 'Você deve selecionar uma nota.';
      return;
    }

    if (this.resposta.resolveuProblema === null || this.resposta.resolveuProblema === undefined) {
      this.msgErro = 'Informe se o problema foi resolvido.';
      return;
    }

    this.enviando = true;

    this.suporteAvaliacaoService.responda(this.token, this.resposta).then((avaliacao: any) => {
      this.avaliacao = avaliacao;
      this.enviado = true;
    }).catch(erro => {
      this.msgErro = erro || 'Não foi possível enviar a avaliação.';
    }).finally(() => {
      this.enviando = false;
    });
  }
}
